import Flagsmith from 'flagsmith'

//
// Our Flagsmith architecture is documented at https://termly.slite.com/app/docs/7O3is47bcUuMGB
//

const OPTIONS = {
  // The flagsmith staging environment is for testing flagsmith deployments.
  // The production endpoint has an environmentID for each of production and
  // staging.
  api: 'https://flagsmith-api.production.termlyapi.io/api/v1/',
  enableLogs: false,
  environmentID: void 0,
}


export default function initFlagsmith(options) {
  // We deliberately leave Flagsmith's flag cache off (it defaults to off).
  // With the cache on, a warm cache makes init() fire a second, detached flag
  // refresh we can't attach a handler to; when that request is blocked (ad or
  // tracker blockers) the orphaned promise rejects and escapes to the global
  // unhandled-rejection handler. With the cache off, init() makes a single
  // awaited request that our caller already guards with .catch(). The cache
  // only ever bought an instant initial paint, never fewer requests, so
  // dropping it costs nothing on the wire.
  return Flagsmith.init({
    ...OPTIONS,
    ...options,
  })
}
